import React, { useState } from 'react'
import { AutoComplete, Button, Flex, Form, Input, Space } from 'antd'
import { useTranslation } from 'react-i18next'
import { AimOutlined } from '@ant-design/icons'
import { get } from '../../../../Common/api'
import { Color } from '../../../../Common/Color'
import { useForm } from 'antd/es/form/Form'

const highlight = (text, highlight) => {
  const parts = text.split(new RegExp(`(${highlight})`, 'gi'))
  return <span> {parts.map((part, i) =>
    <span key={i} style={part.toLowerCase() === highlight.toLowerCase() ? { color: Color.red } : {}}>
      {part}
    </span>)
  } </span>
}

const renderItem = (e, search) => ({
  value: `${e.normalized_name} ${e.zip_code}`,
  key: e.id,
  extra: e,
  label: (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      {highlight(e.normalized_name, search)}
      <span> {highlight(e.zip_code, search)} </span>
    </div>
  )
})

export default function TabletSearch () {
  const { t } = useTranslation()
  const [options, setOptions] = useState([])
  const [selectedOption, setSelectedOption] = useState()
  const [loading, setLoading] = useState(false)
  const [form] = useForm()

  const onFinish = () => {
    if (selectedOption) {
      // Force browser navigation to set cookie
      window.location.href = `/results?lat=${selectedOption.lat}&long=${selectedOption.long}`
    }
    setLoading(false)
  }

  const onFinishFailed = () => {
    setLoading(false)
  }

  const handleSearch = (search, latitude, longitude, callback) => {
    get({
      url: 'public/postal_places',
      params: { search, lat: latitude || '', long: longitude || '' },
      onSuccess: (json) => {
        const newOptions = json.map((e) => renderItem(e, search))
        setOptions(newOptions)
        if (callback) {
          callback(json)
        }
      }
    })
  }

  const geoLoc = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        handleSearch('', position.coords.latitude, position.coords.longitude, (json) => {
          form.setFieldsValue({ search: json[0].normalized_name })
          setOptions([])
          setSelectedOption(json[0])
        })
      })
    }
  }

  const onSelect = (value, option) => {
    setSelectedOption(option.extra)
  }

  return (
  <Flex vertical style={{ backgroundColor: Color.white }}>
    <div style={{ fontSize: '20px', textAlign: 'center', fontWeight: 'bold', margin: '1em 0' }}>
      {t('Public.Search.title')}
    </div>
    <Form
      form={form}
      name="basic"
      onFinish={onFinish}
      autoComplete="off"
      layout="inline"
      onFinishFailed={onFinishFailed}
      style={{ justifyContent: 'center' }}
    >
      <Form.Item
        style={{ width: '200px' }}
        name="search"
        rules={[{ required: true, message: t('Public.Search.required') }]}
      >
        <Space.Compact>
          <AutoComplete
            popupMatchSelectWidth={350}
            options={options}
            showSearch={{ onSearch: handleSearch }}
            onSelect={(value, option) => onSelect(value, option)}
          >
            <Input autoFocus={true} placeholder={t('Public.Search.placeholder')} />
          </AutoComplete>
          <Space.Addon style={{ borderRadius: '0 10px 10px 0' }}>
            <AimOutlined onClick={geoLoc} disabled={loading} />
          </Space.Addon>
        </Space.Compact>
      </Form.Item>
      <Form.Item >
        <Button type="primary" htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
          {t('actions.validate')}
        </Button>
      </Form.Item>
    </Form>
  </Flex>
  )
}
